export const STORY_EMBED_MODAL_COPY = {
  failed: "Could not load the embed settings. Try again.",
  saveError: "Unable to save the embed settings.",
  resetError: "Unable to reset the embed link.",
  expiresNote: (date: string) => `Link works until ${date}.`,
  neverExpiresNote: "Link does not expire.",
  copyOff: "Turn on the embed link to copy its code.",
} as const;
